import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/tags/', { params });
  },
  createData() {
    return Backend.get('/tags/create');
  },
  editData(id) {
    return Backend.get(`/tags/${id}/edit`);
  },
  create(data) {
    return Backend.post('/tags/', data);
  },
  update(data) {
    return Backend.put(`/tags/${data.id}`, data);
  },
  delete(id) {
    return Backend.delete(`/tags/${id}`);
  },
  tree(hash) {
    return Backend.get('/tags/tree', { params: { hash } });
  },
  raw(hash) { // Same as tree, but output list
    return Backend.get('/tags/tree', { params: { hash, raw: 1 } });
  },
};
